export const config = {
	apiBaseUrl: window.env.REACT_APP_BASE_URL,
};

export const endpoints = {
	submitForm: "submitForm",
	userCreation: "userCreation",
	otpValidation: "otpValidation",
	resendOtpCode : "resendOtpCode",
	login: "login",
	forgotPassword: "forgotPassword",
	changePassword: "changePassword",
	verifyContactInfo: "verifyContactInfo",
};
